<template>
    <div style="width: 100%">
        <nav-breadcrumb :menu="[{label :'出库审核'}]"/>
        <el-row>
            <el-col>
                <panel label="出库信息">
                    <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">
                            <el-col :span="24">
                                <el-form-item label="贷款合同："  style="width: 90%">
                                    {{dataForm.t__transactionNo}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="客户名称："  style="width: 90%">
                                    {{dataForm.t__customerName}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="贷款状态："  style="width: 90%">
                                    {{'Financing_'+ dataForm.t__transactionStatus|Status2CN}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="贷款金额："  style="width: 90%">
                                    {{dataForm.t__totalAmount|formatMoney}} 元
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="还款日期：" prop="t__checkoutTime"  label-width="150px">
                                    {{dataForm.t__settleDate?this.$moment(dataForm.t__settleDate).format('YYYY-MM-DD'):''}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="出库原因：" prop="t__reason">
                                   {{dataForm.t__reason}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="代理人：" prop="t__proxyPersonName"  label-width="150px">
                                    {{dataForm.t__proxyPersonName}}
                                </el-form-item>
                            </el-col>

                            <el-col :span="24">
                                <el-form-item label="备注：" prop="t__remarks" style="width: 50%">
                                    {{dataForm.t__remarks}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </panel>
                <panel label="增贷信息" v-if="relatedList.length > 0">
                    <el-form :model="dataForm" :rules="dataFormRules" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg" v-for="(relatedItem, relatedIdx) in relatedList" :key="relatedIdx" style="border:1px solid #C0C4CC">
                            <el-col :span="12">
                                <el-form-item label="贷款编号："  style="width: 90%">
                                    {{relatedItem.rfi__transactionNo}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="贷款金额："  style="width: 90%">
                                    {{relatedItem.rfi__totalAmount|formatMoney}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="贷款状态："  style="width: 90%">
                                    {{'Financing_' + relatedItem.rfi__transactionStatus|Status2CN}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="还款日期："  style="width: 90%">
                                    {{relatedItem.rsettle__settleDate? $moment(dataForm.settle__settleDate).format('YYYY-MM-DD'):''}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </panel>
                <panel label="他项权证">
                    <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">
                            <el-col :span="12" v-for="(item, idx) in dataForm.detail" :key="idx" >
                                <el-form-item  :label="'他项权证号'+(idx+1)+'：'"  style="width: 90%">
                                    {{item.de__hisWarrantNo}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </panel>
                <panel label="相关材料" class="zhengjianxinxi">
                    <div class="zhenjianyyzz zhenjianyyzz2" v-for="(item, idx) in dataForm.detail" :key="idx">
                        <photo-browser v-model="item.de__hisWarrant" type='image' :label="'他项权证'+(idx+1)"/>
                    </div>
                </panel>
                <panel title="附件列表">
                    <files-data-table :files.sync="dataForm.attachments"></files-data-table>
                </panel>
                <panel label="审核流程">
                    <data-table
                        :table-data="approvalArry"
                        :columns="approvalTableColumns"
                        :is-pagination-show="false"
                    />
                </panel>
                <panel label="审核意见">

                    <el-col :span="24">
                        <el-form :model="dataForm" inline >
                            <el-form-item label="审核意见" ><el-input type="textarea" v-model="dataForm.a__remarks" style="width:600px"></el-input></el-form-item>
                        </el-form>

                    </el-col>
                </panel>
            </el-col>
        </el-row>
        <div class="tr xzmt">
            <el-button type="primary" @click="onSubmit('dataForm','Approved')">审核通过</el-button>
            <el-button @click="onSubmit('dataForm','Rejected')">否决</el-button>
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import moment from 'moment'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import Status2CN from "../../filters/Status2CN";
    import Panel from "../../components/Panel";
    import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "HisWarrantApprove",
        data() {
            return {
                applicationId:this.$route.query['applicationId']||'',
                dataForm:{
                    related: []
                },
                dataFormRules:{},
                approvalTableColumns: [
                    {
                        label: '节点',
                        field: 'node',
                        formatter: function (r, c, v) {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '操作人',
                        field: 'approverName'
                    },
                    {
                        label: '操作时间',
                        field: 'time',
                        formatter: function (r, c, v) {
                            return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
                        }
                    },
                    {
                        label: '操作结果',
                        field: 'status'
                    }, {
                        label: '操作备注',
                        field: 'remarks'
                    },
                ],
                approvalArry: {
                    data: [],
                    count: 0,
                },
                approvalListcount: 0,
                approvalList: {},
            }
        },
        filters: {

            Status2CN
        },
        computed: {
            relatedList() {
                return this.dataForm.related.filter(item=>item.rfi__transactionNo)
            }
        },
        mounted() {
            if (this.applicationId) {
                this.getData()
            }
        },
        methods:{
            setApproval: function () {
                let count = 2
                this.approvalArry.data.push(
                    {
                        node: '提交申请',
                        approverName: this.dataForm.u__userName,
                        time: this.dataForm.t__createdDate,
                        status: '提交成功',
                        remarks: '',

                    }
                )

                for (var i = 0; i < this.approvalList.length; i++) {
                    let name = this.approvalList[i].a__nodeName


                    this.approvalArry.data.push(
                        {
                            node: name,
                            approverName: this.approvalList[i].a__approverName,
                            time: this.approvalList[i].a__approvingDate,
                            status: Status2CN(this.approvalList[i].a__approvingStatus),
                            remarks: this.approvalList[i].a__remarks,

                        }
                    )
                    count++


                }
                this.approvalArry.count = count
            },
            getData: function () {
                xhr.getHisWarrantTx({
                    't.applicationId': this.$route.query['applicationId']
                }, res=>{
                    try{
                        if(res.data.status == 'success') {
                            this.dataForm = res.data.data
                            this.approvalList = res.data.data.approvals.filter(item=>item.a__approverId)
                            this.setApproval()
                        }
                    }catch(e){}
                })
            },
            onSubmit: function (formName,status) {
                xhr.updateApproveHisWarrantCheckout(
                    {
                        't__applicationId': this.applicationId,
                        'a__approvingStatus':status,
                        'a__remarks': this.dataForm.a__remarks,
                        'a__checked':true
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.$router.push({
                                    name: 'HisWarrantApproveListView'
                                })
                            }else{
                                this.$message.error(res.data.msgs[0].text)
                            }

                        }catch (e) {

                            this.$message.error(error.msgs[0].text)

                        }
                    }
                )
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/HisWarrantApprove.vue